<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
// import { fetchAuthSession } from "aws-amplify/auth";
export default {
  data: () => ({
    fab: null,
  }),
  // async mounted() {
  //   await fetchAuthSession({ forceRefresh: true });
  // },
  methods: {},
};
</script>

<style>
@import "./styles/theme.css";

html,
body,
.v-application {
  font-family: "DM Sans", system-ui, -apple-system, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: linear-gradient(
    155deg,
    #eefaf4 0%,
    #e8f7f0 28%,
    #f0fdf9 55%,
    #f5faf8 100%
  ) !important;
}

h1,
h2,
h3,
h4,
h5,
h6,
.v-toolbar-title,
.nav-brand-name,
.sign-in-title,
.topbar-org-name,
.hero-title {
  font-family: "Sora", "DM Sans", sans-serif;
}

.fontSize11px {
  font-size: 11px !important;
}
.fontsize30px {
  font-size: 30px !important;
}
.fontsize40px {
  font-size: 40px !important;
}

/* ::-webkit-scrollbar {
  display: none;
}  */
slide-in-from-top {
  animation: slideInFromTop 1s ease-out;
}
@keyframes slideInFromTop {
  0% {
    transform: translateY(-100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
.slide-in-from-bottom {
  animation: slideInFromBottom 1s ease-out;
}
@keyframes slideInFromBottom {
  0% {
    transform: translateY(100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
.MaxWidthVariant1 {
  max-width: 150px !important;
  font-size: 12px !important;
}
.MaxWidthVariant2 {
  max-width: 300px !important;
  font-size: 12px !important;
}

.FontSize {
  font-size: 12px !important;
}
.FontSize8px {
  font-size: 8px !important;
}
.fontsize9px {
  font-size: 9px !important;
}
.fontsize10px {
  font-size: 10px !important;
}
.fontsize11px {
  font-size: 11px !important;
}
.fontsize12px {
  font-size: 12px !important;
}
.fontsize13px {
  font-size: 13px !important;
}
.fontsize14px {
  font-size: 14px !important;
}
.FontSize10px {
  font-size: 12px !important;
  font-weight: bold !important;
}
.fontSize {
  font-size: 10px;
}
.fontSize {
  font-size: 10px;
}
.fontsize20px {
  font-size: 20px;
}
.v-input .v-label {
  font-size: 12px;
}
.field_height.v-text-field .v-input__control .v-input__slot {
  min-height: 12px !important;
  display: flex !important;
  align-items: center !important;
}
.field_label_size.v-input .v-label {
  font-size: 12px;
}
.v-select
  .v-input__control
  .v-input__slot
  .v-select__slot
  .v-select__selections {
  padding: 0 !important;
  min-height: 0 !important;
}

.v-select-list .v-list-item {
  min-height: 0 !important;
}

.v-select-list .v-list-item .v-list-item__content {
  padding: 14px 0 !important;
}
.maxWidthVariant1 {
  max-width: 200px !important;
  font-size: 8px !important;
}
.TableClass table {
  width: 150% !important;
}

.TableClass td {
  font-size: 11px !important;
}

.TableClass th {
  font-size: 10px !important;
}
/* body {
  overflow-y: hidden;
} */

.FieldPointerCursor :hover {
  cursor: pointer !important;
}
.CountryCodeMaxWidth {
  max-width: 100px !important;
}
#content {
  height: calc(100vh - 65px);
  overflow-y: hidden;
}

.v-text-field .v-input_control .v-input_slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

/* .vdataTablescroll .v-data-table__wrapper::-webkit-scrollbar {
  width: 12px !important;
}

.vdataTablescroll .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: red !important;
  border-radius: 6px !important;
}

.vdataTablescroll .v-data-table__wrapper::-webkit-scrollbar-track {
  background-color: orange;
} */

/* Firefox */
* {
  scrollbar-width: thin !important;
  scrollbar-color: #0c9f6b #cdcdcd;
}

/* Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  height: 6px !important;
  width: 6px !important;
  scrollbar-color: #0c9f6b #cdcdcd;
}

*::-webkit-scrollbar-track {
  background: #ffffff;
}

*::-webkit-scrollbar-thumb {
  scrollbar-width: thin !important;
  background-color: #0c9f6b !important;
  border-radius: 10px;
  border: 0px solid #ffffff;
}
.TableDataClass td {
  font-size: 12px !important;
}
.MaxFieldWidth {
  max-width: 300px !important;
  height: 20px !important;
}
.SelectFieldWidth {
  max-width: 200px !important;
  height: 20px !important;
}
.TooltipColor {
  background-color: #0c9f6b !important;
}
.MaxWidthSearch {
  max-width: 500px !important;
}
.TableDataStyle th {
  font-size: 12px !important;
  color: #474545 !important;
  font-weight: 600 !important;
}
.TableDataStyle td {
  font-size: 11px !important;
}
.v-select .v-select__selection-text {
  font-size: 13px !important;
}
.v-text-field input {
  font-size: 12px !important;
  font-weight: 400 !important;
}
.v-date-picker-months__content .v-btn.v-btn--active {
  border-radius: 6px !important;
  background-color: #98bfff !important; /* Change to your desired blue shade */
  color: white !important; /* Optional: Ensure text is readable */
}
.no-gap {
  padding-left: 4px !important; /* reduce default left padding */
}

.no-gap .v-list-item__prepend {
  margin-right: 4px !important; /* reduce icon-to-text spacing */
}

.v-list-item__prepend > .v-badge .v-icon,
.v-list-item__prepend > .v-icon,
.v-list-item__append > .v-badge .v-icon,
.v-list-item__append > .v-icon {
  opacity: 1 !important;
  color: #ffffff !important;
}
/* Row borders except last child and expanded content row */
.tableBorderColor.v-data-table
  .v-data-table__wrapper
  table
  tbody
  tr:not(.v-data-table__tr--expanded):not(:last-child)
  td {
  border-top: 1px solid black !important;
  border-right: 1px solid black !important;
  border-bottom: none !important;
  box-shadow: none !important;
  background-color: transparent !important;
}

/* Remove border for expanded row content */
.tableBorderColor.v-data-table
  .v-data-table__wrapper
  table
  tbody
  tr.v-data-table__tr--expanded
  td {
  border-top: none !important;
  box-shadow: none !important;
  border-bottom: none !important;
  background-color: transparent !important;
}
.CardBorderRadius {
  border-radius: 25px 0px 25px 0px !important;
}
.mdi-checkbox-marked::before {
  content: "\F0132";
  color: #0c9f6b !important;
}

/* ── Global select dropdown menus ── */
.pharma-select-menu,
.small-select-menu,
.approvals-select-menu,
.products-select-menu,
.territories-select-menu,
.workflow-select-menu,
.product-dialog-select-menu {
  border-radius: 12px !important;
  background: #ffffff !important;
  box-shadow:
    0 8px 24px rgba(16, 49, 37, 0.1),
    0 2px 8px rgba(16, 49, 37, 0.06) !important;
  overflow: hidden;
  border: 1px solid #e8eceb;
  z-index: 2700 !important;
}

.product-dialog-select-menu {
  z-index: 2800 !important;
}

.pharma-select-menu .v-list,
.small-select-menu .v-list,
.approvals-select-menu .v-list,
.products-select-menu .v-list,
.territories-select-menu .v-list,
.workflow-select-menu .v-list,
.product-dialog-select-menu .v-list {
  padding: 6px !important;
}

.pharma-select-menu .v-list-item,
.small-select-menu .v-list-item,
.approvals-select-menu .v-list-item,
.products-select-menu .v-list-item,
.territories-select-menu .v-list-item,
.workflow-select-menu .v-list-item,
.product-dialog-select-menu .v-list-item {
  border-radius: 8px !important;
  margin: 2px 0 !important;
  min-height: 40px !important;
  padding-inline: 12px !important;
  transition: background-color 0.2s ease, color 0.2s ease !important;
}

.pharma-select-menu .v-list-item-title,
.small-select-menu .v-list-item-title,
.approvals-select-menu .v-list-item-title,
.products-select-menu .v-list-item-title,
.territories-select-menu .v-list-item-title,
.workflow-select-menu .v-list-item-title,
.product-dialog-select-menu .v-list-item-title {
  font-size: 13px !important;
  font-weight: 500 !important;
  font-family: "DM Sans", sans-serif !important;
}

.small-select-menu .v-list-item-title {
  font-size: 14px !important;
}

.small-select-menu .v-list-item {
  min-height: 34px !important;
}

.pharma-select-menu .v-list-item:hover,
.small-select-menu .v-list-item:hover,
.approvals-select-menu .v-list-item:hover,
.products-select-menu .v-list-item:hover,
.territories-select-menu .v-list-item:hover,
.workflow-select-menu .v-list-item:hover,
.product-dialog-select-menu .v-list-item:hover {
  background: #f0fdf4 !important;
}

.pharma-select-menu .v-list-item--active,
.small-select-menu .v-list-item--active,
.approvals-select-menu .v-list-item--active,
.products-select-menu .v-list-item--active,
.territories-select-menu .v-list-item--active,
.workflow-select-menu .v-list-item--active,
.product-dialog-select-menu .v-list-item--active {
  background: #f0fdf4 !important;
  color: #047857 !important;
}

.pharma-select-menu .v-list-item--active .v-list-item-title,
.small-select-menu .v-list-item--active .v-list-item-title,
.approvals-select-menu .v-list-item--active .v-list-item-title,
.products-select-menu .v-list-item--active .v-list-item-title,
.territories-select-menu .v-list-item--active .v-list-item-title,
.workflow-select-menu .v-list-item--active .v-list-item-title,
.product-dialog-select-menu .v-list-item--active .v-list-item-title {
  color: #047857 !important;
  font-weight: 600 !important;
}

.pharma-select-menu .v-list::-webkit-scrollbar-thumb,
.small-select-menu .v-list::-webkit-scrollbar-thumb,
.approvals-select-menu .v-list::-webkit-scrollbar-thumb,
.products-select-menu .v-list::-webkit-scrollbar-thumb,
.territories-select-menu .v-list::-webkit-scrollbar-thumb,
.workflow-select-menu .v-list::-webkit-scrollbar-thumb,
.product-dialog-select-menu .v-list::-webkit-scrollbar-thumb {
  background-color: #059669 !important;
}

/* ── Global outlined form field styling (v-text-field, v-select, v-autocomplete, v-textarea) ── */
.v-application .v-input .v-field--variant-outlined {
  background: #fafbfc !important;
  border-radius: 16px !important;
  min-height: 40px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease !important;
}

.v-application .v-input .v-field--variant-outlined .v-field__outline {
  --v-field-border-opacity: 1;
  color: #e5e7eb;
}

.v-application .v-input .v-field--variant-outlined.v-field--focused .v-field__outline {
  color: #059669 !important;
}

.v-application .v-input .v-field--variant-outlined.v-field--focused {
  box-shadow: 0 0 0 1px rgba(5, 150, 105, 0.15) !important;
}

.v-application .v-input .v-field--variant-outlined .v-field__append-inner .v-icon,
.v-application .v-input .v-field--variant-outlined .v-field__prepend-inner .v-icon,
.v-application .v-input .v-field--variant-outlined .v-select__menu-icon {
  color: #059669 !important;
  opacity: 1;
}

.v-application .v-input--density-compact .v-field--variant-outlined {
  min-height: 40px;
}

/* ── Global row action menus (ServiceWRK-style) ── */
.pharma-actions-menu {
  border-radius: 12px !important;
  background: #ffffff !important;
  box-shadow:
    0 10px 28px rgba(15, 23, 42, 0.1),
    0 2px 8px rgba(15, 23, 42, 0.04) !important;
  border: 1px solid rgba(15, 23, 42, 0.08) !important;
  overflow: hidden !important;
}

.pharma-actions-list.v-list,
.pharma-actions-list {
  padding: 6px !important;
  min-width: 210px;
  background: #ffffff !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 2px !important;
}

.pharma-actions-menu .pharma-actions-item.v-list-item {
  flex: none !important;
  width: 100% !important;
  min-height: unset !important;
  padding: 0 !important;
  margin: 0 !important;
  border-radius: 8px !important;
  background: transparent !important;
  border: none !important;
  color: #1f2937 !important;
  cursor: pointer !important;
  transition:
    background-color 0.26s cubic-bezier(0.4, 0, 0.2, 1),
    color 0.26s ease,
    transform 0.26s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.pharma-actions-menu .pharma-actions-item .v-list-item__overlay,
.pharma-actions-menu .pharma-actions-item .v-list-item__underlay {
  opacity: 0 !important;
  transition: opacity 0.26s ease !important;
}

.pharma-actions-menu .pharma-actions-item.v-list-item--active {
  background: transparent !important;
}

.pharma-actions-menu .pharma-actions-item .v-list-item__content {
  display: flex !important;
  align-items: center !important;
  gap: 10px !important;
  padding: 10px 12px !important;
  width: 100% !important;
  min-height: 40px !important;
  border-radius: 8px !important;
  transition:
    background-color 0.26s cubic-bezier(0.4, 0, 0.2, 1),
    color 0.26s ease !important;
}

.pharma-actions-menu .pharma-actions-item .v-list-item__prepend,
.pharma-actions-menu .pharma-actions-item .v-list-item__append {
  display: none !important;
  margin: 0 !important;
  min-width: 0 !important;
  width: 0 !important;
}

.pharma-actions-menu .pharma-actions-item > iconify-icon,
.pharma-actions-menu .pharma-actions-item > .v-icon,
.pharma-actions-menu .pharma-actions-item .pharma-actions-icon,
.pharma-actions-menu .pharma-actions-item .v-list-item__content > iconify-icon,
.pharma-actions-menu .pharma-actions-item .v-list-item__content > .v-icon {
  flex-shrink: 0 !important;
  margin: 0 !important;
  color: #4b5563 !important;
  transition:
    color 0.26s cubic-bezier(0.4, 0, 0.2, 1),
    transform 0.26s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.pharma-actions-label,
.pharma-actions-menu .pharma-actions-item .pharma-actions-label,
.pharma-actions-menu .pharma-actions-item > span:not(.v-icon),
.pharma-actions-menu .pharma-actions-item .v-list-item__content > span {
  font-family: "DM Sans", sans-serif !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #1f2937 !important;
  line-height: 1.35 !important;
  transition: color 0.26s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.pharma-actions-menu .pharma-actions-item:hover,
.pharma-actions-menu .pharma-actions-item.v-list-item:hover {
  background: #f4f6f8 !important;
  transform: translateX(4px) !important;
}

.pharma-actions-menu .pharma-actions-item:hover .v-list-item__content {
  background: transparent !important;
}

.pharma-actions-menu .pharma-actions-item:hover > iconify-icon,
.pharma-actions-menu .pharma-actions-item:hover > .v-icon,
.pharma-actions-menu .pharma-actions-item:hover .pharma-actions-icon,
.pharma-actions-menu .pharma-actions-item:hover .v-list-item__content > iconify-icon,
.pharma-actions-menu .pharma-actions-item:hover .v-list-item__content > .v-icon {
  transform: scale(1.08) !important;
  color: #1f2937 !important;
}

.pharma-actions-menu .pharma-actions-item:hover .pharma-actions-label,
.pharma-actions-menu .pharma-actions-item:hover > span:not(.v-icon),
.pharma-actions-menu .pharma-actions-item:hover .v-list-item__content > span {
  color: #111827 !important;
}

/* Thin divider before destructive / after destructive groups */
.pharma-actions-menu .pharma-actions-item--destructive,
.pharma-actions-menu .pharma-actions-item--destructive + .pharma-actions-item {
  position: relative;
}

.pharma-actions-menu .pharma-actions-item--destructive::before,
.pharma-actions-menu .pharma-actions-item--destructive + .pharma-actions-item::before {
  content: "";
  position: absolute;
  top: -2px;
  left: 10px;
  right: 10px;
  height: 1px;
  background: #eceef2;
  pointer-events: none;
  transition: none !important;
}

/* Primary / status — soft lavender */
.pharma-actions-menu .pharma-actions-item--primary,
.pharma-actions-menu .pharma-actions-item--primary.v-list-item {
  background: #f6f3ff !important;
  transition:
    background-color 0.26s cubic-bezier(0.4, 0, 0.2, 1),
    color 0.26s ease,
    transform 0.26s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.pharma-actions-menu .pharma-actions-item--primary .pharma-actions-icon,
.pharma-actions-menu .pharma-actions-item--primary > .v-icon,
.pharma-actions-menu .pharma-actions-item--primary > iconify-icon {
  color: #6d28d9 !important;
  transition:
    color 0.26s cubic-bezier(0.4, 0, 0.2, 1),
    transform 0.26s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.pharma-actions-menu .pharma-actions-item--primary .pharma-actions-label,
.pharma-actions-menu .pharma-actions-item--primary > span:not(.v-icon) {
  color: #5b21b6 !important;
  font-weight: 600 !important;
  transition: color 0.26s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.pharma-actions-menu .pharma-actions-item--primary:hover,
.pharma-actions-menu .pharma-actions-item--primary.v-list-item:hover {
  background: #ede9ff !important;
  transform: translateX(4px) !important;
}

.pharma-actions-menu .pharma-actions-item--primary:hover .pharma-actions-icon,
.pharma-actions-menu .pharma-actions-item--primary:hover > .v-icon,
.pharma-actions-menu .pharma-actions-item--primary:hover > iconify-icon {
  color: #5b21b6 !important;
  transform: scale(1.08) !important;
}

.pharma-actions-menu .pharma-actions-item--primary:hover .pharma-actions-label,
.pharma-actions-menu .pharma-actions-item--primary:hover > span:not(.v-icon) {
  color: #4c1d95 !important;
}

/* Destructive — red */
.pharma-actions-menu .pharma-actions-item--destructive,
.pharma-actions-menu .pharma-actions-item--destructive.v-list-item {
  transition:
    background-color 0.26s cubic-bezier(0.4, 0, 0.2, 1),
    color 0.26s ease,
    transform 0.26s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.pharma-actions-menu .pharma-actions-item--destructive .pharma-actions-icon,
.pharma-actions-menu .pharma-actions-item--destructive > .v-icon,
.pharma-actions-menu .pharma-actions-item--destructive > iconify-icon {
  color: #ef4444 !important;
  transition:
    color 0.26s cubic-bezier(0.4, 0, 0.2, 1),
    transform 0.26s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.pharma-actions-menu .pharma-actions-item--destructive .pharma-actions-label,
.pharma-actions-menu .pharma-actions-item--destructive > span:not(.v-icon) {
  color: #ef4444 !important;
  transition: color 0.26s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.pharma-actions-menu .pharma-actions-item--destructive:hover,
.pharma-actions-menu .pharma-actions-item--destructive.v-list-item:hover {
  background: #fef2f2 !important;
  transform: translateX(4px) !important;
}

.pharma-actions-menu .pharma-actions-item--destructive:hover .pharma-actions-icon,
.pharma-actions-menu .pharma-actions-item--destructive:hover > .v-icon,
.pharma-actions-menu .pharma-actions-item--destructive:hover > iconify-icon {
  color: #dc2626 !important;
  transform: scale(1.08) !important;
}

.pharma-actions-menu .pharma-actions-item--destructive:hover .pharma-actions-label,
.pharma-actions-menu .pharma-actions-item--destructive:hover > span:not(.v-icon) {
  color: #dc2626 !important;
}

/* Override inline Vuetify icon colors */
.pharma-actions-menu .pharma-actions-item .v-icon {
  opacity: 1 !important;
}

.pharma-actions-menu
  .pharma-actions-item:not(.pharma-actions-item--destructive):not(.pharma-actions-item--primary)
  .v-icon {
  color: #4b5563 !important;
}

.pharma-actions-menu
  .pharma-actions-item:not(.pharma-actions-item--destructive):not(.pharma-actions-item--primary):hover
  .v-icon {
  color: #1f2937 !important;
  transform: scale(1.08) !important;
  transition:
    color 0.26s cubic-bezier(0.4, 0, 0.2, 1),
    transform 0.26s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

/* ── Global product-dialog pattern (territory & list dialogs) ── */
.product-dialog-overlay {
  border-radius: 16px !important;
  overflow: hidden;
}

.product-dialog-overlay--fullscreen {
  border-radius: 0 !important;
}

.product-dialog-card {
  border-radius: 16px !important;
  overflow: hidden;
  background: #f8faf9;
  border: 1px solid #e8eceb;
  box-shadow:
    0 24px 48px rgba(16, 49, 37, 0.14),
    0 8px 16px rgba(16, 49, 37, 0.06);
}

.product-dialog-card--fullscreen {
  border-radius: 0 !important;
  border: none !important;
  height: 100%;
  min-height: 100vh;
  background: #f4f7f6;
}

.product-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 20px;
  background: #ffffff;
  border-bottom: 1px solid #f0f2f1;
  flex-shrink: 0;
}

.product-dialog-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  flex: 1;
}

.product-dialog-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.product-dialog-header-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 50%;
  background: rgba(16, 185, 129, 0.12);
  color: #059669;
  border: 1px solid rgba(16, 185, 129, 0.2);
}

.product-dialog-title {
  font-family: "Sora", "DM Sans", sans-serif;
  font-size: 17px;
  font-weight: 600;
  color: #059669;
  margin: 0;
  line-height: 1.3;
  letter-spacing: -0.02em;
}

.product-dialog-subtitle {
  font-family: "DM Sans", sans-serif;
  font-size: 12px;
  color: #6b7280;
  margin: 2px 0 0;
  line-height: 1.4;
}

.product-dialog-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border: none;
  border-radius: 50%;
  background: #f3f4f6;
  color: #6b7280;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease;
}

.product-dialog-close:hover {
  background: rgba(16, 185, 129, 0.1);
  color: #059669;
  transform: scale(1.05);
}

.product-dialog-header-export {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  background: rgba(16, 185, 129, 0.1);
  color: #059669;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
}

.product-dialog-header-export:hover {
  background: rgba(16, 185, 129, 0.18);
  transform: scale(1.05);
}

.product-dialog-search-field {
  max-width: 200px;
  min-width: 160px;
}

.product-dialog-search-field :deep(.v-field) {
  border-radius: 999px !important;
  background: #f8faf9 !important;
  min-height: 36px !important;
}

.product-dialog-search-field :deep(.v-field__outline) {
  color: #e5e7eb !important;
}

.product-dialog-search-field :deep(.v-field--focused .v-field__outline) {
  color: #059669 !important;
}

.product-dialog-body {
  padding: 16px 20px;
  background: #f4f7f6;
}

.product-dialog-body--table {
  padding: 12px 16px 16px;
}

.product-dialog-body--form {
  padding: 16px;
  overflow-y: auto;
}

.product-dialog-section--map {
  min-height: 600px;
  margin-bottom: 0;
}

.product-dialog-filter-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  background: #ffffff;
  border-bottom: 1px solid #f0f2f1;
  flex-wrap: wrap;
}

.product-dialog-table-card {
  background: #ffffff;
  border: 1px solid #e8eceb;
  border-radius: 14px;
  overflow: hidden;
}

.product-dialog-table-card .territory-dialog-table :deep(thead th) {
  background: linear-gradient(180deg, #f0fdf4 0%, #ecfdf5 100%) !important;
  color: #047857 !important;
  font-family: "DM Sans", sans-serif !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  letter-spacing: 0.05em !important;
  text-transform: uppercase !important;
  border-bottom: 1px solid #d1fae5 !important;
}

.product-dialog-table-card .territory-dialog-table :deep(tbody tr) {
  transition: background-color 0.2s ease;
}

.product-dialog-table-card .territory-dialog-table :deep(tbody tr:hover) {
  background: #f8fafc !important;
}

.product-dialog-section {
  background: #ffffff;
  border: 1px solid #e8eceb;
  border-radius: 14px;
  margin-bottom: 16px;
  overflow: hidden;
}

.product-dialog-section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f2f1;
  background: #fafbfc;
}

.product-dialog-section-title {
  font-family: "DM Sans", sans-serif;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #6b7280;
}

.product-dialog-section-body {
  padding: 16px;
}

.product-dialog-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 14px 20px;
  background: #ffffff;
  border-top: 1px solid #f0f2f1;
}

.product-dialog-btn-confirm {
  font-family: "DM Sans", sans-serif !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  color: #ffffff !important;
  letter-spacing: normal !important;
  text-transform: none !important;
  border-radius: 999px !important;
  padding: 0 24px !important;
  min-height: 38px !important;
  background: linear-gradient(135deg, #34d399 0%, #10b981 55%, #059669 100%) !important;
  box-shadow: 0 4px 14px rgba(5, 150, 105, 0.35) !important;
  border: none !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease !important;
}

.product-dialog-btn-confirm:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(5, 150, 105, 0.4) !important;
}

.product-dialog-btn-cancel {
  font-family: "DM Sans", sans-serif !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  color: #6b7280 !important;
  background: transparent !important;
  letter-spacing: normal !important;
  text-transform: none !important;
  border-radius: 999px !important;
  padding: 0 20px !important;
  min-height: 38px !important;
  border: 1px solid #e5e7eb !important;
}

.product-dialog-btn-cancel:hover {
  color: #374151 !important;
  background: #f3f4f6 !important;
}

.product-dialog-btn-add {
  font-family: "DM Sans", sans-serif !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  color: #ffffff !important;
  letter-spacing: normal !important;
  text-transform: none !important;
  border-radius: 999px !important;
  min-height: 36px !important;
  background: linear-gradient(135deg, #34d399 0%, #10b981 55%, #059669 100%) !important;
  box-shadow: 0 2px 10px rgba(5, 150, 105, 0.3) !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease !important;
}

.product-dialog-btn-add:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 14px rgba(5, 150, 105, 0.38) !important;
}

.product-dialog-input :deep(.v-field) {
  border-radius: 12px !important;
  background: #fafbfc !important;
}

.product-dialog-input :deep(.v-field--focused .v-field__outline) {
  color: #059669 !important;
}

.territory-patch-action-icon {
  cursor: pointer;
  transition: transform 0.2s ease, color 0.2s ease;
}

.territory-patch-action-icon:hover {
  transform: scale(1.12);
}
.landinglist .v-list-item__prepend {
  align-items: center !important;
  align-self: center !important;
  display: flex !important;
  grid-area: prepend !important;
  width: 26px !important;
}
.landinglistchild .v-list-item__prepend {
  align-items: center !important;
  align-self: center !important;
  display: flex !important;
  grid-area: prepend !important;
  width: 20px !important;
  min-width: 20px !important;
  margin-left: 0 !important;
}
.FontSize .v-field__input {
  font-size: 12px !important;
}

.FontSize .v-field-label {
  font-size: 12px !important;
}

.FontSize .v-field-label--floating {
  font-size: 10px !important;
  transform: translateY(-40%) !important;
}
.Listings .v-list-item-title {
  font-size: 12px !important;
}

/* Native action buttons outside Vuetify */
button[type="button"]:not(.v-btn) {
  text-transform: none;
  font-family: "DM Sans", sans-serif;
  letter-spacing: 0.02em;
}

/* Typography — buttons & tabs (Title Case in markup, no forced uppercase) */
.v-btn {
  text-transform: none !important;
  letter-spacing: 0.02em !important;
  font-family: "DM Sans", sans-serif !important;
  font-weight: 500 !important;
}

.v-btn--size-default {
  height: 34px !important;
  min-height: 34px !important;
  font-size: 13px !important;
}

.v-btn--size-small {
  height: 30px !important;
  min-height: 30px !important;
  font-size: 12px !important;
}

.v-btn--size-large {
  height: 40px !important;
  min-height: 40px !important;
  font-size: 13px !important;
}

.v-btn.text-capitalize {
  text-transform: none !important;
}

.v-btn--size-x-small {
  font-size: 11px !important;
  font-weight: 500 !important;
}

.v-btn--size-x-large {
  font-size: 14px !important;
}

.v-btn.gradient-bg,
.v-btn.gradient-btn {
  font-weight: 600 !important;
}

.v-tab {
  text-transform: none !important;
  font-weight: 500 !important;
  font-size: 13px !important;
  letter-spacing: 0.02em !important;
}

.v-tab.text-capitalize {
  text-transform: none !important;
}

.v-toolbar-title {
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: 0.01em !important;
}

.v-card-title {
  text-transform: none !important;
}

.gradient-btn {
  background: -webkit-linear-gradient(
    135deg,
    #6ee7b7 0%,
    #34d399 28%,
    #10b981 55%,
    #059669 82%,
    #047857 100%
  ) !important;
  -webkit-text-fill-color: white !important;
}
.gradient-bg {
  background: -webkit-linear-gradient(
    135deg,
    #6ee7b7 0%,
    #34d399 28%,
    #10b981 55%,
    #059669 82%,
    #047857 100%
  ) !important;
  background: -moz-linear-gradient(
    135deg,
    #6ee7b7 0%,
    #34d399 28%,
    #10b981 55%,
    #059669 82%,
    #047857 100%
  ) !important;
  background: -o-linear-gradient(
    135deg,
    #6ee7b7 0%,
    #34d399 28%,
    #10b981 55%,
    #059669 82%,
    #047857 100%
  ) !important;
  background: -ms-linear-gradient(
    135deg,
    #6ee7b7 0%,
    #34d399 28%,
    #10b981 55%,
    #059669 82%,
    #047857 100%
  ) !important;
  background: linear-gradient(
    135deg,
    #6ee7b7 0%,
    #34d399 28%,
    #10b981 55%,
    #059669 82%,
    #047857 100%
  ) !important;
}

/* Light glass navigation drawer overrides */
.pharma-nav-drawer .v-list-item__prepend > .v-icon,
.pharma-nav-drawer .v-list-item__append > .v-icon {
  color: #6b7280 !important;
  opacity: 1 !important;
}

.pharma-nav-drawer .v-list-item--active .v-list-item__prepend > .v-icon,
.pharma-nav-drawer .active .v-list-item__prepend > .v-icon {
  color: #0c9f6b !important;
}

.pharma-layout .pharma-nav-drawer.v-navigation-drawer {
  position: relative !important;
  transform: none !important;
  flex-shrink: 0;
}

.pharma-layout .pharma-nav-drawer.v-navigation-drawer--is-mobile {
  position: fixed !important;
}

/* ── Global pharma form field system ── */
.pharma-field-group {
  background: #ffffff;
  border: 1px solid #e8eceb;
  border-radius: 14px;
  padding: 16px;
  margin-bottom: 16px;
}

.pharma-field-group:last-child {
  margin-bottom: 0;
}

.pharma-field-group__header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: "DM Sans", sans-serif;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #6b7280;
  margin-bottom: 14px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f2f1;
}

.pharma-field-group__header iconify-icon,
.pharma-field-group__header .v-icon {
  color: #9ca3af;
  flex-shrink: 0;
}

.pharma-field-wrap {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.pharma-field-label {
  display: block;
  font-family: "DM Sans", sans-serif;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-bottom: 6px;
  line-height: 1.2;
}

.pharma-field-label--filter {
  color: #047857;
}

.pharma-form-fields .pharma-field-label:not(.pharma-field-label--filter),
.pharma-field-group .pharma-field-label:not(.pharma-field-label--filter) {
  color: #6b7280;
}

.pharma-field-required {
  color: #ef4444;
  font-weight: 700;
}

.pharma-form-fields {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.pharma-filter-fields {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Form / grouped card inputs — rounded, light tint */
.pharma-form-fields .v-input .v-field--variant-outlined,
.pharma-field-group .v-input .v-field--variant-outlined {
  background: #fafbfc !important;
  border-radius: 12px !important;
  min-height: 40px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease !important;
}

.pharma-form-fields .v-input .v-field--variant-outlined .v-field__outline,
.pharma-field-group .v-input .v-field--variant-outlined .v-field__outline {
  --v-field-border-opacity: 1;
  color: #e5e7eb;
}

.pharma-form-fields .v-input .v-field--variant-outlined.v-field--focused,
.pharma-field-group .v-input .v-field--variant-outlined.v-field--focused {
  box-shadow: 0 0 0 1px rgba(5, 150, 105, 0.15) !important;
}

.pharma-form-fields .v-input .v-field--variant-outlined.v-field--focused .v-field__outline,
.pharma-field-group .v-input .v-field--variant-outlined.v-field--focused .v-field__outline {
  color: #059669 !important;
}

/* Vuetify floating labels → uppercase above-field look in form contexts */
.pharma-form-fields .v-input .v-label,
.pharma-field-group .v-input .v-label {
  font-family: "DM Sans", sans-serif !important;
  font-size: 10px !important;
  font-weight: 700 !important;
  letter-spacing: 0.08em !important;
  text-transform: uppercase !important;
  color: #6b7280 !important;
  opacity: 1 !important;
}

.pharma-form-fields .v-input .v-label.v-field-label--floating,
.pharma-field-group .v-input .v-label.v-field-label--floating {
  color: #059669 !important;
}

.pharma-form-fields .v-input .v-label .v-label__asterisk,
.pharma-field-group .v-input .v-label .v-label__asterisk {
  color: #ef4444 !important;
}

.pharma-form-fields .v-input .v-field__append-inner .v-icon,
.pharma-form-fields .v-input .v-field__prepend-inner .v-icon,
.pharma-form-fields .v-input .v-select__menu-icon,
.pharma-field-group .v-input .v-field__append-inner .v-icon,
.pharma-field-group .v-input .v-field__prepend-inner .v-icon,
.pharma-field-group .v-input .v-select__menu-icon {
  color: #059669 !important;
  opacity: 1;
}

/* Filter panels — pill inputs, white background, uppercase selection text */
.pharma-filter-fields .v-input .v-field--variant-outlined {
  background: #ffffff !important;
  border-radius: 999px !important;
  min-height: 40px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease !important;
}

.pharma-filter-fields .v-input .v-field--variant-outlined .v-field__outline {
  --v-field-border-opacity: 1;
  color: #e5e7eb;
}

.pharma-filter-fields .v-input .v-field--variant-outlined.v-field--focused {
  box-shadow: 0 0 0 1px rgba(5, 150, 105, 0.15) !important;
}

.pharma-filter-fields .v-input .v-field--variant-outlined.v-field--focused .v-field__outline {
  color: #059669 !important;
}

.pharma-filter-fields .v-input .v-field__append-inner .v-icon,
.pharma-filter-fields .v-input .v-field__prepend-inner .v-icon,
.pharma-filter-fields .v-input .v-select__menu-icon {
  color: #059669 !important;
  opacity: 1;
}

.pharma-filter-fields .v-select .v-select__selection-text,
.pharma-filter-fields .v-autocomplete .v-autocomplete__selection-text,
.pharma-filter-fields .v-text-field input {
  text-transform: uppercase;
  font-weight: 600;
  color: #1f2937;
  font-size: 12px;
}

.pharma-filter-fields .v-text-field input::placeholder {
  text-transform: none;
  font-weight: 400;
  color: #9ca3af;
}

/* Utility class for individual field components */
.pharma-field-input.v-input .v-field--variant-outlined,
.v-input.pharma-field-input .v-field--variant-outlined {
  background: #fafbfc !important;
  border-radius: 12px !important;
}

.pharma-filter-fields .pharma-field-input.v-input .v-field--variant-outlined,
.pharma-filter-fields .v-input.pharma-field-input .v-field--variant-outlined {
  background: #ffffff !important;
  border-radius: 999px !important;
}

/* Radio / checkbox groups inside field cards */
.pharma-field-group .v-radio-group .v-label,
.pharma-field-group .v-checkbox .v-label {
  font-size: 13px !important;
  font-weight: 500 !important;
  letter-spacing: normal !important;
  text-transform: none !important;
  color: #374151 !important;
}
</style>
<style>
/* Global white tooltips */
.pharma-tooltip,
.v-overlay-container .pharma-tooltip {
  background: #ffffff !important;
  color: #1a1d21 !important;
  border: 1px solid rgba(0, 0, 0, 0.06) !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1) !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  font-family: "DM Sans", sans-serif !important;
  padding: 6px 12px !important;
  border-radius: 8px !important;
  opacity: 1 !important;
}
</style>
